import type { IGlossaryEntry, IGlossaryEntryCreate } from '~/types/glossary'

import config from '~/config'
import { request } from '~/utils/request'

/** @doc https://toolbox-dev-europe-west9-6xd26izywq-od.a.run.app/#get-/glossary */
export const getGlossary = (): Promise<IPaginatedResponse<IGlossaryEntry[]>> => {
  return request({
    url: `${config.TOOLBOX_API}/glossary`,
  })
}

/** @doc https://toolbox-dev-europe-west9-6xd26izywq-od.a.run.app/#post-/glossary */
export const createGlossaryEntry = (data: IGlossaryEntryCreate): Promise<void> => {
  const { long_description, short_description, title } = data

  return request({
    data: {
      long_description,
      short_description,
      title,
    },
    method: 'POST',
    url: `${config.TOOLBOX_API}/glossary`,
  })
}

/** @doc https://toolbox-dev-europe-west9-6xd26izywq-od.a.run.app/#put-/glossary */
export const updateGlossaryEntry = (data: IGlossaryEntry): Promise<void> => {
  return request({
    data,
    method: 'PUT',
    url: `${config.TOOLBOX_API}/glossary`,
  })
}

/** @doc https://toolbox-dev-europe-west9-6xd26izywq-od.a.run.app/#delete-/glossary/-glossaryItemID- */
export const deleteGlossaryEntry = (id: string): Promise<void> => {
  return request({
    method: 'DELETE',
    url: `${config.TOOLBOX_API}/glossary/${id}`,
  })
}
